import styled from 'styled-components';

export const ArticleCardStyles = styled.div`
	.title {
		margin-bottom: 0.5rem;
	}

	.category {
		margin-bottom: 1rem;
	}

	.meta {
		margin-bottom: 0.5rem;
		color: ${({ theme }) => theme.v3.colors.dark[0]};
	}
`;
